import { PropsWithChildren } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { cn } from "@/lib/cn";

export function Section({
  id,
  eyebrow,
  title,
  description,
  children
}: PropsWithChildren<{
  id: string;
  eyebrow: string;
  title: string;
  description: string;
}>) {
  const reduceMotion = useReducedMotion();
  return (
    <section
      id={id}
      aria-labelledby={`${id}-title`}
      className="mx-auto max-w-6xl px-4 py-16 md:px-6 md:py-24"
    >
      <motion.header
        initial={reduceMotion ? { opacity: 1, y: 0 } : { opacity: 0, y: 8 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-10% 0px -10% 0px" }}
        transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
        className="mb-10 max-w-2xl"
      >
        <p className="text-[11px] font-medium uppercase tracking-[0.18em] text-muted/85">
          {eyebrow}
        </p>
        <h2
          id={`${id}-title`}
          className={cn(
            "mt-3 text-balance text-[28px] font-semibold leading-[1.12] tracking-tight text-fg md:text-4xl"
          )}
        >
          {title}
        </h2>
        <p className="mt-3 text-pretty text-base leading-relaxed text-muted/90 md:text-lg">
          {description}
        </p>
      </motion.header>
      {children}
    </section>
  );
}

